import * as React from 'react';
import {PropsWithChildren, useState} from "react";
import {AppNavBar} from "@/component/layout/AppNavBar";
import {TransMultiAddView} from "@/component/view/TransMultiAddView";

interface Props {
}

export function PcPage(props: PropsWithChildren<Props>) {
    const [transMultiAddMode, setTransMultiAddMode] = useState(false);

    return <div style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    }}>
        <AppNavBar onTransMultiAdd={() => setTransMultiAddMode(true)}/>

        <div style={{
            flex: 1,
            overflow: 'auto'
        }}>
            <div style={{
                minWidth: 1200,
                maxWidth: 1200,
                margin: '0 auto',
                padding: '16px',
            }}>
                {props.children}
            </div>
        </div>

        {transMultiAddMode && (
            <div style={{borderTop: "#666666 solid 1px", position: "relative"}}>
                <button style={{position: "absolute", top: 8, right: 8}} onClick={() => setTransMultiAddMode(false)}>X</button>
                <TransMultiAddView/>
            </div>
        )}
    </div>;
}